import mutations, { getDefaultState } from './mutations'
import actions from './actions'

export const faturamento = {
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions
}
